import API from 'services/API';

/** Modèles de checklist (pool partagé stages / vols / aéroports). */
export const getTemplates = () => API.get('/checklist/template');

export const getTemplate = id => API.get(`/checklist/template/${id}`);

export const addTemplate = template => API.post('/checklist/template', template);

export const editTemplate = (template, id) => API.put(`/checklist/template/${id}`, template);

export const deleteTemplate = id => API.delete(`/checklist/template/${id}`);

/** Ajoute le modèle à tous les vols actifs de la course (génération manuelle ensuite). */
export const applyTemplateToActiveFlights = id =>
  API.post(`/checklist/template/${id}/apply-to-flights`);

/** Bouton « Générer / Mettre à jour les checklists ». */
export const generate = () => API.post('/checklist/generate');

/** Modèles cochés sur un vol (plusieurs checklists possibles). */
export const getFlightTemplates = flightId => API.get(`/checklist/flight/${flightId}/templates`);

export const setFlightTemplates = (flightId, templateIds) =>
  API.put(`/checklist/flight/${flightId}/templates`, { templateIds });

/** Instances (mobile / listes par jour). */
export const getInstancesByDate = date => API.get(`/checklist/instance?date=${date}`);

/** Instances liées à une entité (sections des formulaires web). */
export const getInstancesByEntity = (entityType, entityId) =>
  API.get(`/checklist/instance/byEntity?entityType=${entityType}&entityId=${entityId}`);

/** Toutes les instances de la course (page de gestion web). */
export const getAllInstances = () => API.get('/checklist/instance/all');

export const getInstance = id => API.get(`/checklist/instance/${id}`);

export const updateItem = (instanceId, itemId, status) =>
  API.patch(`/checklist/instance/${instanceId}/item/${itemId}`, { status });

/** Suppression d'une instance (force = suppression d'une instance remplie). */
export const deleteInstance = (id, force = false) =>
  API.delete(`/checklist/instance/${id}${force ? '?force=true' : ''}`);
